<template>
  <div>
    <!-- 注册 -->
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> / <a href="">关于汇利兴</a>
        </div>
        <div class="page-center-box w-100">
          <div class="ksbj-box w-100">
            <div class="box-info1 w-100 text-center">— 会员注册 —</div>
            <div class="box-info3 w-100" style="display: flex; justify-content: center">
              <div v-for="(item, index) in tabData" :key="index">
                <span :class="{ active: tabIndex == index }" @click="tabChange(index)"><i>{{ item }}</i></span>
              </div>
            </div>
            <div class="box-info2 w-100 center-center">
              <form action="" class="pull-left" method="post">
                <!-- <div class="box1 w-100">
                  <span><i>*</i> 用户名：</span>
                  <input @blur="userNameBlur" type="text" class="text" name="" id="" v-model="registerForm.username"
                    placeholder="请输入英文字母和数字组合的登录名" />
                  <p v-if="showName" style="margin-left: 18%; color: red">
                    用户名已存在
                  </p>
                </div> -->
                <div class="box1 w-100">
                  <span><i>*</i> 姓名：</span>
                  <input type="text" class="text" name="" id="" v-model="registerForm.realname" placeholder="请输入您的全名" />
                </div>
                <div class="box1 w-100">
                  <span><i>*</i> 手机号码：</span>
                  <input @blur="userNamePhone" type="text" class="text" maxlength="11" name="" id=""
                    v-model="registerForm.phone" placeholder="请输入常用手机号码" />
                  <p v-if="showPhone" style="margin-left: 18%; color: red">
                    手机号已存在
                  </p>
                </div>
                <!-- <div class="box1 w-100 yzm">
                  <span><i>*</i> 验证码：</span>
                  <input type="text" class="text" name="" id="" v-model="registerForm.vcodeNum" placeholder="请输入验证码" />
                  <img @click="getCodeImg" :src="codeImg" />
                </div> -->
                <div class="box1 w-100 yzm">
                  <span><i>*</i> 手机验证码：</span>
                  <input type="text" class="text" name="" id="" v-model="registerForm.vcode" placeholder="请输入手机验证码" />
                  <a href="javascript:;" @click="getCode">{{
                    codeBtn.codeText
                    }}</a>
                </div>
                <div class="box1 w-100">
                  <span><i>*</i> 密码：</span>
                  <input type="password" class="text" name="" id="" v-model="registerForm.password"
                    placeholder="请输入8-20位且必须包含字母和数字的密码" />
                </div>
                <div class="box1 w-100">
                  <span><i>*</i> 确认密码：</span>
                  <input type="password" class="text" name="" id="" v-model="registerForm.repassword"
                    placeholder="请再次输入密码" @blur="passwordCom" />
                </div>

                <div class="box3 w-100" v-show="tabIndex == 1">
                  <div class="box1 w-100">
                    <span><i>*</i> 职业：</span>
                    <select v-model="registerForm.occupation" name="">
                      <option value="">请选择</option>
                      <option value="采购、总务">采购、总务</option>
                      <option value="设计、技术人员">设计、技术人员</option>
                      <option value="设计兼采购">设计兼采购</option>
                      <option value="维护人员">维护人员</option>
                      <option value="品质管理">品质管理</option>
                      <option value="生产制造、安装工事人员">
                        生产制造、安装工事人员
                      </option>
                      <option value="管理层">管理层</option>
                      <option value="其它">其它</option>
                    </select>
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 公司名称：</span>
                    <input type="text" class="text" name="" id="" v-model="registerForm.firmName"
                      placeholder="请输入您的公司名称" />
                  </div>
                </div>
                <div class="box3 w-100" v-show="tabIndex == 3">
                  <div class="box1 w-100">
                    <span><i>*</i> 地址信息：</span>
                    <div class="box4 between-center">
                      <select name="province" id="province">
                        <option value="请选择">请选择</option>
                      </select>
                      <select name="city" id="city">
                        <option value="请选择">请选择</option>
                      </select>
                      <select name="town" id="town">
                        <option value="请选择">请选择</option>
                      </select>
                    </div>
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 详细地址：</span>
                    <input type="text" class="text" name="" id="" value="" placeholder="请输入除省市区以外的其他地址信息，如道路、门牌号等" />
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 部门：</span>
                    <input type="text" class="text" name="" id="" value="" placeholder="请输入您的在职部门" />
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 电话号码：</span>
                    <div class="box4 between-center">
                      <input type="text" class="text" name="" id="" value="" placeholder="区号" />
                      <input type="text" class="text" name="" id="" value="" placeholder="电话号码" />
                      <input type="text" class="text" name="" id="" value="" placeholder="分机（可不输）" />
                    </div>
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 邮箱：</span>
                    <input type="text" class="text" name="" id="" value="" placeholder="请输入您的邮箱地址" />
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 从业人数：</span>
                    <select name="">
                      <option value="">请选择</option>
                      <option value="">1-9人</option>
                      <option value="">10-99人</option>
                      <option value="">100人-499人</option>
                      <option value="">500人-999人</option>
                      <option value="">1000人以上</option>
                    </select>
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 行业类别：</span>
                    <div class="box4 between-center">
                      <select name="">
                        <option value="请选择">请选择</option>
                      </select>
                      <select name="">
                        <option value="请选择">请选择</option>
                      </select>
                      <select name="">
                        <option value="请选择">请选择</option>
                      </select>
                    </div>
                  </div>
                  <div class="box1 w-100">
                    <span><i>*</i> 发票信息：</span>
                    <div class="box5">
                      <label class="radio-inline">
                        <input type="radio" name="billInfoNessesity" checked id="BillInfoNessesityNo" value="1" />不需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" name="billInfoNessesity" id="BillInfoNessesityYes" value="0" />需要
                      </label>
                      <div class="box6">
                        <label class="radio-inline">
                          <input type="radio" name="billInfoDiv" id="BillInfoDivC" value="1" />普通发票
                        </label>
                        <div class="box6">
                          <div class="box1 w-100">
                            <span><i>*</i> 公司名称：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                          <div class="box1 w-100">
                            <span><i>*</i> 纳税人识别号：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                        </div>
                        <label class="radio-inline">
                          <input type="radio" name="billInfoDiv" checked id="BillInfoDivT" value="0" />增值税专用发票
                        </label>
                        <div class="box6">
                          <div class="box1 w-100">
                            <span><i>*</i> 公司名称：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                          <div class="box1 w-100">
                            <span><i>*</i> 纳税人识别号：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                          <div class="box1 w-100">
                            <span><i>*</i> 注册地址：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                          <div class="box1 w-100">
                            <span><i>*</i> 注册电话：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                          <div class="box1 w-100">
                            <span><i>*</i> 开户银行：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                          <div class="box1 w-100">
                            <span><i>*</i> 银行账号：</span>
                            <input type="text" class="text" name="" id="" value="" placeholder="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box7 w-100">
                  <!-- <el-checkbox v-model="checked"></el-checkbox> -->
                  注册即代表您同意
                  <a href="JavaScript:void(0)">《网站使用规则》</a> 、<a href="JavaScript:void(0)">《汇利兴FA电商平台客户注册须知说明》</a>、<a
                    href="JavaScript:void(0)">《隐私政策》</a>
                </div>

                <div class="btns" @click="register">提交</div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="用户协议" :visible.sync="dialogVisible" width="50%" :before-close="handleClose"
      :close-on-click-modal="false">
      <div v-html="userAgreementContent"></div>
      <span slot="footer" class="dialog-footer">
        <button class="conmask-btn " @click="handleAgree">
          同意并继续
        </button>
        <button class="disagree-btn" @click="handleClose">
          不同意
        </button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible1" width="20%" :before-close="handleClose1"
      :close-on-click-modal="false">
      <div class="statusIcon">
        <img src="../../assets/images/icon_md.png" />
        <p style="margin-top: 1.5rem;">
          您需要同意《用户协议》，否则您将无法使用汇利兴平台服务。请再次阅读同意并提交。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="conmask-btn " @click="handleOK">
          好的
        </button>
        <button class="disagree-btn" @click="handleMyNo">
          我不同意
        </button>
      </span>
    </el-dialog>
    <!-- <script src="js/area.js" type="text/javascript" charset="utf-8"></script>
		<script src="js/select.js" type="text/javascript" charset="utf-8"></script>
		<script type="text/javascript">
			$('.ksbj-box .box-info3 span').click(function(){
				if($(this).attr('class') != 'active'){
					$('.ksbj-box .box-info3 span').removeClass('active').eq($(this).index()).addClass('active')
					$('.ksbj-box .box-info2 .pull-left .box3').show()
				}
				if($(this).index() == 0){
					$('.ksbj-box .box-info2 .pull-left .box3').hide()
				}else{
					$('.ksbj-box .box-info2 .pull-left .box3').show()
				}
			})
			$('input[name=billInfoNessesity]').click(function(){
				if($(this).val() == '0'){
					$('.ksbj-box .box-info2 .pull-left .box5>.box6').show()
				}else{
					$('.ksbj-box .box-info2 .pull-left .box5>.box6').hide()
				}
				if($('input[name=billInfoDiv]:checked').val() == '0'){
					$('.ksbj-box .box-info2 .pull-left .box5>.box6 .box6').hide().eq(1).show()
				}else{
					$('.ksbj-box .box-info2 .pull-left .box5>.box6 .box6').hide().eq(0).show()
				}
			})
			$('input[name=billInfoDiv]').click(function(e){
				if($(this).val() == '0'){
					$('.ksbj-box .box-info2 .pull-left .box5>.box6 .box6').hide().eq(1).show()
				}else{
					$('.ksbj-box .box-info2 .pull-left .box5>.box6 .box6').hide().eq(0).show()
				}
			})
		</script> -->
  </div>
</template>

<script>
import {
  getRegist,
  getMyCode,
  whetherUser,
  getwebsites,
  getDeviceId
} from '@/common/http.js';
import { message } from '@/common/common.js';
import axios from 'axios';
import { loginCode } from '../../common/http';
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      tabData: ['注册个人会员', '注册企业会员'],
      tabIndex: 0,
      registerForm: {
        realname: '', // 姓名
        password: '', // 密码
        repassword: '', // 确认密码
        phone: '', // 电话
        vcodeNum: '', // 验证码
        vcode: '', // 手机验证码
        username: '', // 用户名
        firmName: '', // 公司名字
        occupation: '', // 职业
        isFirm: 0 // 是否企业用户1，是，0否
      },
      codeBtn: {
        codeTime: 60,
        codeText: '获取验证码',
        codeStatus: true
      },
      rules: {
        phone: {
          rule: /^1[3456789]\d{9}$/,
          msg: '手机号格式错误'
        },
        password: {
          rule: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/g,
          msg: '请输入8-20位且必须包含字母和数字的密码'
        },
        vcode: {
          rule: /^[0-9]{4}$/,
          msg: '请输入4位数字验证码'
        }
      },
      codeImg: '',
      showPhone: false,
      showName: false,
      checked: false,
      userAgreementContent: ''
    };
  },
  mounted() {
    this.getCodeImg();
    this.getData();
    this.dialogVisible1 = true;

    if (!localStorage.getItem('deviceId')) {
      this.toGetDeviceId();
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
      }
    }
  },
  methods: {
    toGetDeviceId() {
      getDeviceId().then(res => {
        if (res.result) {
          localStorage.setItem('deviceId', res.data);
        }
      });
    },
    getData() {
      // userAgreement  汇利兴FA电商平台客户注册须知说明
      // privacyPolicy   隐私政策
      // shareRules   网站使用规则
      getwebsites({
        keyword: 'userAgreement'
      }).then(res => {
        this.userAgreementContent = res.data.value;
      });
    },

    handleAgree() {
      this.dialogVisible = false;
    },
    handleOK() {
      this.dialogVisible = true;
      this.dialogVisible1 = false;
    },
    handleMyNo() {
      this.dialogVisible1 = false;
      this.$router.go(-1);
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible1 = true;
    },
    handleClose1() {
      this.dialogVisible = false;
      this.$router.go(-1);
    },
    tabChange(index) {
      this.tabIndex = index;
      this.registerForm.isFirm = index;
    },
    getCodeImg() {
      this.codeImg =
        'https://hxfahlx.huixinggroup.com/-img-code.htm?d=' +
        new Date().getTime();
    },
    getCode() {
      if (!this.registerForm.phone) {
        message({
          message: '手机号不能为空！'
        });
        return;
      }
      if (!this.validate('phone')) {
        return;
      }
      if (!this.codeBtn.codeStatus) {
        message({
          message: '请稍后再试~',
          type: 'warning'
        });
        return;
      }
      // 请求验证码
      const loading = this.$loading({
        lock: true,
        text: '发送中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
      this.VerifyCode();
      this.timerId = setInterval(() => {
        let codetime = this.codeBtn.codeTime;
        codetime--;
        this.codeBtn.codeTime = codetime;
        this.codeBtn.codeText = codetime + 's';
        if (codetime < 1) {
          clearInterval(this.timerId);
          this.codeBtn.codeText = '重新获取';
          this.codeBtn.codeTime = 60;
          this.codeBtn.codeStatus = true;
          this.isChick = true;
        }
      }, 1000);
    },
    userNameBlur(val) {
      if (this.registerForm.username === '') {
        return;
      }
      whetherUser({ search: this.registerForm.username, type: 2 }).then(res => {
        if (res.result) {
          this.showName = false;
        } else {
          this.showName = true;
        }
      });
    },
    userNamePhone(val) {
      if (this.registerForm.phone === '') {
        return;
      }
      if (!this.validate('phone')) {
        return;
      }
      whetherUser({ search: this.registerForm.phone, type: 1 }).then(res => {
        if (res.result) {
          this.showPhone = false;
        } else {
          this.showPhone = true;
        }
      });
    },
    async VerifyCode() {
      try {
        // let { msg } = await getMyCode({
        //   mobile: this.registerForm.phone,
        //   type: 1
        // });
        let { msg } = await loginCode({
          mobile: this.registerForm.phone,
          type: 1
        });
        setTimeout(() => {
          this.$message({
            message: msg,
            type: 'success'
          });
        }, 2000);
      } catch (err) {
        this.$message.error(err.data.msg);
      }
    },
    // 判断验证是否符合要求，合法性校验
    validate(key) {
      let bool = true;
      if (!this.rules[key].rule.test(this.registerForm[key])) {
        // 提示信息
        this.$message(this.rules[key].msg);
        // 取反
        bool = false;
        return false;
      }
      return bool;
    },
    passwordCom() {
      if (this.repassword != this.password) {
        message({
          message: '两次密码输入不一致！'
        });
      }
    },
    register() {
      // if (!this.registerForm.username) {
      //   message({
      //     message: '请输入用户名！'
      //   });
      //   return;
      // }
      if (!this.registerForm.realname) {
        message({
          message: '请输入姓名！'
        });
        return;
      }
      if (!this.registerForm.password) {
        message({
          message: '请输入密码！'
        });
        return;
      }
      if (!this.validate('password')) {
        return;
      }
      if (!this.registerForm.repassword) {
        message({
          message: '请确认密码！'
        });
        return;
      }
      if (this.registerForm.repassword != this.registerForm.password) {
        message({
          message: '两次密码输入不一致！'
        });
        return;
      }
      if (!this.registerForm.phone) {
        message({
          message: '手机号不能为空！'
        });
        return;
      }
      if (!this.validate('phone')) {
        return;
      }
      if (!this.registerForm.vcode) {
        message({
          message: '请输入手机验证码！'
        });
        return;
      }
      if (!this.validate('vcode')) {
        return;
      }
      getRegist(this.registerForm).then(res => {
        if (res.result) {
          message({
            message: '注册成功！',
            type: 'success'
          });
          let obj = {
            password: this.password,
            phone: this.phone
          };
          localStorage.setItem('account', JSON.stringify(obj));
          localStorage.setItem('userInfo', JSON.stringify(res.data.user));
          localStorage.setItem('userExt', JSON.stringify(res.data.userExt));
          localStorage.setItem('token', JSON.stringify(res.data.token));

          this.$store.commit('SET_USER', res.data.user)
          this.$store.commit('SET_TOKEN', res.data.token)

          // window.location.reload()
          setTimeout(() => {
            this.$router.push({
              path: '/'
            });
          }, 1000);
        } else {
          message({
            message: res.data.msg,
            type: 'error'
          });
        }
      });
    }
  }
};
</script>

<style scoped>
/deep/ .el-dialog__body {
  max-height: 60vh;
  overflow: auto;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #ccc;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.conmask-btn {
  width: 142px;
  height: 36px;
  background: #ffcc00;
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 20px;
  position: relative;
  display: flex;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  border: none;
}

.disagree-btn {
  border: none;
  width: 142px;
  height: 36px;
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 20px;
  position: relative;
  display: flex;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #ffcc00;
}

.statusIcon {
  height: 15vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.statusIcon img {
  width: 50px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/register/register.vue